export const groups = [
  { code: '10', name: 'Consultas' },
  { code: '20', name: 'Diagnóstico por imagem' },
  { code: '30', name: 'Exames laboratoriais / Patologia' },
  { code: '40', name: 'Procedimentos clínicos' },
  { code: '50', name: 'Procedimentos cirúrgicos' },
  { code: '60', name: 'Hemoterapia' },
  { code: '70', name: 'Órteses, próteses e materiais' },
  { code: '80', name: 'Anestesia' },
  { code: '90', name: 'Diárias e taxas' },
];

export function getCBHPMGroup(code) {
  return groups.find(item => item.code === code);
}

export function getCBHPMGroupName(code) {
  const group = getCBHPMGroup(code);
  return group ? group.name : null;
}

export default groups;
